import React, { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import MDTypography from "components/MDTypography";
import Swal from 'sweetalert2';
import AppointmentsApi from '../../../../Classes/API/Appointments/AppointmentsApi';
import AddManyToManyReq from '../../../../Classes/Models/Requests/AddManyToManyReq';
import SearchStringOrIntReq from '../../../../Classes/Models/Requests/SearchStringOrIntReq';

const DayToBeCopied = ({ AppDay1, AppDay2, setAppDay }) => {
    let navigate = useNavigate();
    const isMounted = useRef(false)
    const [isUpdated, setIsUpdated] = useState(true);
    const [updateCount, setUpdateCount] = useState(0);
    // const [DayStats, setDayStats] = useState({
    //     SessionsCount: 0,
    //     TherapistsCount: 0
    // })
    useEffect(() => {
        isMounted.current = true;

        // let sessCount = 0;
        // let patientCount = 0;
        // let therapistCount = 0;
        // for (let i = 0; i < AppDay1.getTherapists.length; i++) {
        //     therapistCount++;
        //     for (let j = 0; j < AppDay1.getTherapists[i].getAppointmentHours.length; j++) {
        //         for (let k = 0; k < AppDay1.getTherapists[i].getAppointmentHours[j].getListedAccountingSessions?.length; k++) {
        //             sessCount++;
        //         }

        //     }
        // }
        // setDayStats({
        //     SessionsCount: sessCount,
        //     TherapistsCount: therapistCount
        // });

        return () => {
            isMounted.current = false;
            console.log(isMounted);
        }
    }, []);

    const GoToDay = () => {
        navigate(
            '/Appointments/AppDayDetailsSimple',
            {
                state: {
                    AppDay: AppDay1,
                }
            }
        )
    }
    const GoToSelectHours = () => {
        navigate(
            '/Appointments/AppointmentDaySelectHour',
            {
                state: {
                    AppDay: AppDay1,
                }
            }
        )
    }

    // const CopyDay = async () =>{
    //     Swal.fire({
    //         icon:'info',
    //         title: "Grab a Coffee while we do the work.",
    //         text: "This may take a long time. If you dont get a response refresh the page after an hour.",
    //         showConfirmButton: false
    //     })
    //     let req  = new AddManyToManyReq();
    //     req.Id1 = AppDay1.id;
    //     req.Id2 = AppDay2.id;
    //     let res = await AppointmentsApi.CopyAppointmentDay(req);
    //     if(res.status == "Success"){
    //         Swal.fire({
    //             icon:'success',
    //             title: "Day structure imported successfully",
    //             text: res.message,
    //             showConfirmButton: true
    //         }).then(() => {
    //             window.location.reload();
    //         })
    //     }
    //     else{
    //         Swal.fire({
    //             icon:'error',
    //             title: "Import operation failed",
    //             text: res.message,
    //         })
    //     }
    // }

    const CopyDay = async () => {
        const AddTherapistToDay = async (DayId, TherapistId) => {
            let addTherapistReq = new AddManyToManyReq();
            addTherapistReq.Id1 = DayId;
            addTherapistReq.Id2 = TherapistId;
            let res = await AppointmentsApi.AddTherapistToAppointmentDay(addTherapistReq);
            return res;
        }
        const updateLog = (logData) => {
            log += logData + "\n";
            Swal.getTitle().textContent = logData;
            console.log(logData);
        }
        let similarSessionsOnly = document.getElementById('SimilarOnlyCheck').checked;

        let confirmation = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, start import'
        });
        if (!confirmation.isConfirmed) {
            return;
        }
        let log = "Started importing \n";
        Swal.fire({
            title: "Fetching Schedule Data",
            icon: "info",
            text: "Importing Schedule...",
            showConfirmButton: false,
            allowOutsideClick: true,
            showCloseButton: true,
            backdrop: false,
            didOpen: () => {
                Swal.showLoading()
            }
        });
        let getDayReq = new SearchStringOrIntReq();
        getDayReq.SearchInt = AppDay1.id;
        let getDayRes = await AppointmentsApi.GetAppointmentDayByIdSimplified(getDayReq);
        console.log({ getDayRes });
        if (getDayRes.status != "Success") {

            Swal.fire({
                title: "Failed",
                icon: "error",
                text: "Failed to fetch schedule data.",

            });
        }
        if (getDayRes.data.getTherapists.length < 1) {
            Swal.fire({
                title: "Failed",
                icon: "error",
                text: "Failed to fetch schedule data.",

            });
            return;
        }
        var appDay1 = getDayRes.data;
        var appDay2 = AppDay2;
        var day1AccSessions = [];
        updateLog("Adding Therapists to Schedule");
        for (let i = 0; i < appDay1.getTherapists.length; i++) {
            let therapist = appDay1.getTherapists[i];
            updateLog("Adding " + therapist.therapistName + " to schedule.")
            let addTherapistRes = await AddTherapistToDay(appDay2.id, therapist.therapistId);
            if (addTherapistRes.status == "Success") {
                updateLog("Added " + therapist.therapistName + " to schedule.")
                if (isMounted.current) {
                    setAppDay(addTherapistRes.data)
                }

                therapist.getAppointmentHours.forEach((hour) => {
                    hour.getListedAccountingSessions.forEach((session) => {
                        session.getAppointmentHour = hour;
                        day1AccSessions.push(session);
                    })
                })
            }
            else {
                updateLog("Failed to add " + therapist.therapistName + " to schedule.")
            }
        }

        updateLog("Finished Adding Therapists.");

        updateLog("Adding Sessions");
        for (let i = 0; i < day1AccSessions.length; i++) {
            let session = day1AccSessions[i];
            updateLog("Finding Session for " + session.patientName);
            let similarSessionReq = {
                sessionId: session.id,
                dayId: appDay2.id,
                any: similarSessionsOnly
            };
            let similarSessionRes = await AppointmentsApi.GetSimilarSession(similarSessionReq);
            updateLog(similarSessionRes.message);
            if (similarSessionRes.data == null) {
                continue;
            }
            let newHour = similarSessionRes.data;
            let newAppDay = AppDay2;
            let therapistIndexInDay = newAppDay.getTherapists.findIndex(x => x.id == newHour.appointmentDayTherapistId);
            let hourIndexInTherapist = newAppDay.getTherapists[therapistIndexInDay].getAppointmentHours.findIndex(x => x.id == newHour.id);
            newAppDay.getTherapists[therapistIndexInDay].getAppointmentHours[hourIndexInTherapist] = newHour;
            setAppDay(newAppDay);
        }
        updateLog("Finished");
        console.log(log)

        Swal.fire({
            title: "Done",
            icon: "success",
            text: "Imported Sessions Successfully",
        });

    }


    const CopyDaySessionsFirst = async () => {
        const AddTherapistToDay = async (DayId, TherapistId) => {
            let addTherapistReq = new AddManyToManyReq();
            addTherapistReq.Id1 = DayId;
            addTherapistReq.Id2 = TherapistId;
            let res = await AppointmentsApi.AddTherapistToAppointmentDay(addTherapistReq);
            return res;
        }
        const updateLog = (logData) => {
            log += logData + "\n";
            Swal.getTitle().textContent = logData;
            console.log(logData);
        }
        const updateAppDay = async (newHour) => {
            let newAppDay = AppDay2;
            let therapistIndexInDay = newAppDay.getTherapists.findIndex(x => x.id == newHour.appointmentDayTherapistId);
            // if not found, get appointment day again
            if (therapistIndexInDay == -1) {
                console.log("Therapist not found in day, getting day again");
                let _getDayReq = new SearchStringOrIntReq();
                getDayReq.SearchInt = AppDay2.id;
                let _getDayRes = await AppointmentsApi.GetAppointmentDayByIdSimplified(getDayReq);
                if (_getDayRes.status != "Success") {
                    console.log("Failed to get day");
                    return;
                }
                newAppDay = _getDayRes.data;
                setAppDay(newAppDay);
                return;
            }

            let hourIndexInTherapist = newAppDay.getTherapists[therapistIndexInDay].getAppointmentHours.findIndex(x => x.id == newHour.id);
            newAppDay.getTherapists[therapistIndexInDay].getAppointmentHours[hourIndexInTherapist] = newHour;
            setAppDay(newAppDay);
        }
        let similarSessionsOnly = document.getElementById('SimilarOnlyCheck').checked;

        let confirmation = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, start import'
        });
        if (!confirmation.isConfirmed) {
            return;
        }
        let log = "Started importing \n";
        Swal.fire({
            title: "Fetching Schedule Data",
            icon: "info",
            text: "Importing Schedule...",
            showConfirmButton: false,
            allowOutsideClick: true,
            showCloseButton: true,
            backdrop: false,
            didOpen: () => {
                Swal.showLoading()
            }
        });
        let getDayReq = new SearchStringOrIntReq();
        getDayReq.SearchInt = AppDay1.id;
        let getDayRes = await AppointmentsApi.GetAppointmentDayByIdSimplified(getDayReq);
        console.log({ getDayRes });
        if (getDayRes.status != "Success") {

            Swal.fire({
                title: "Failed",
                icon: "error",
                text: "Failed to fetch schedule data.",

            });
        }
        if (getDayRes.data.getTherapists.length < 1) {
            Swal.fire({
                title: "Failed",
                icon: "error",
                text: "Failed to fetch schedule data.",

            });
            return;
        }
        var appDay1 = getDayRes.data;
        var appDay2 = AppDay2;
        let day1SessionsCount = 0;
        let day1TherapistsCount = 0;
        for (let i = 0; i < appDay1.getTherapists.length; i++) {
            day1TherapistsCount++;
            for (let j = 0; j < appDay1.getTherapists[i].getAppointmentHours.length; j++) {
                for (let k = 0; k < appDay1.getTherapists[i].getAppointmentHours[j].getListedAccountingSessions?.length; k++) {
                    day1SessionsCount++;
                }

            }
        }
        var day1AccSessions = [];
        let sessionsCount = 0;
        updateLog("Adding Therapists to Schedule");
        for (let i = 0; i < appDay1.getTherapists.length; i++) {
            let therapist = appDay1.getTherapists[i];
            var TherapistAccSessions = [];
            updateLog("Adding " + therapist.therapistName + " to schedule.")
            let addTherapistRes = await AddTherapistToDay(appDay2.id, therapist.therapistId);
            if (addTherapistRes.status == "Success") {
                updateLog("Added " + therapist.therapistName + " to schedule.")
                if (isMounted.current) {
                    setAppDay(addTherapistRes.data)
                }

                therapist.getAppointmentHours.forEach((hour) => {
                    hour.getListedAccountingSessions.forEach((session) => {
                        session.getAppointmentHour = hour;
                        day1AccSessions.push(session);
                        TherapistAccSessions.push(session);
                    })
                })
            }
            else {
                updateLog("Failed to add " + therapist.therapistName + " to schedule.")
            }

            console.log(therapist.therapistName + " Sessions: ", TherapistAccSessions)
            //Add Sessions

            for(let j = 0; j < TherapistAccSessions.length; j++){
                sessionsCount++;
                let session = TherapistAccSessions[j];
                updateLog("Finding Session for " + session.patientName);
                let similarSessionReq = {
                    sessionId: session.id,
                    dayId: appDay2.id,
                    any: !similarSessionsOnly
                };
                Swal.getHtmlContainer().innerText = "Importing Sessions... (" 
                + sessionsCount.toString() 
                + " out of " + day1SessionsCount.toString() + ")";
                console.log(similarSessionReq)
                let similarSessionRes = await AppointmentsApi.GetSimilarSession(similarSessionReq);
                console.log(similarSessionRes)
                updateLog("Session import result: " + similarSessionRes.message);  
                if (similarSessionRes.data == null) {
                    continue;
                }
                await updateAppDay(similarSessionRes.data);
            }

        }


        updateLog("Finished");
        console.log(log)

        Swal.fire({
            title: "Done",
            icon: "success",
            text: "Imported Sessions Successfully",
        });

    }
    return (
        <div >
            <div className="row">


                <div className="col-md-6">

                    <MDTypography className="custom-card">
                        <span>Day Id:</span> <p>{AppDay1.id}</p>
                    </MDTypography>

                </div>

                <div className="col-md-6">
                    <MDTypography className="custom-card">
                        <span>Date:</span> <p>{AppDay1.dateDay && AppDay1.dateDay.split("T")[0]}</p>
                    </MDTypography>
                </div>

            </div>
            <div className="row mt-4" style={{ justifyContent: 'space-between' }}>
                <div className="col-lg-6 row">
                    <button onClick={() => CopyDaySessionsFirst()} className="btn btn-dark ml-2 mr-3">Start Smart Copy</button>
                    <input type="checkbox" id="SimilarOnlyCheck" />
                    <MDTypography className="custom-card ml-2">
                        <span>Similar Sessions Only</span>
                    </MDTypography>
                </div>
                <div className="col-lg-6">
                    <button onClick={() => GoToSelectHours()} className="btn btn-dark ml-2">Go to Hours</button>
                    <button onClick={() => GoToDay()} className="btn btn-dark ml-2">Go to Day</button>
                </div>
            </div>
        </div>



    )
}
export default DayToBeCopied